// Libarary Class
import { Component, OnInit, ViewEncapsulation, Inject, AfterViewInit, OnDestroy, } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
const _ = require('lodash');
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { Router } from '@angular/router';

// Service Class
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';

// Class
import { MasterConstants } from './../../../../common/constants/master-constants';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { CommonService } from '../../../../services/common/common.service';
import {
  CppUserListFormsData,
  CppUserListData,
  LineError,
} from './cpp-create-edit-user-list-data';
import { CppUserListService } from '../../../../services/cpp/cpp-user-list.service';

import { DatePipe } from '@angular/common';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-cpp.cpp-create-edit-user-list',
  templateUrl: './cpp-create-edit-user-list.component.html',
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' })
      ),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [
        // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
  styleUrls: ['./cpp-create-edit-user-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CppUserListCreateEditComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  shipToData: any;
  deliverToData: any;
  dashboardFilter: DashboardFilter;
  displayedColumns: string[] = [
    'firstName',
    'lastName',
    'email',
    'action',
  ];
  deliverTo: any;
  enable: any;
  editToolKit: any;
  isSearchClicked: any;
  cppUserListDS: MatTableDataSource<CppUserListData>;
  originalProductItemsDataSource: MatTableDataSource<CppUserListData>;
  errorsList: Array<string> = [];
  error = false;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  nextErrorId = 0;
  isEditMode = false;
  hasChangeAdded = false;
  accessTypeMode = false;
  deliveryInstruction: MatTableDataSource<any>;
  contactTypeList: any = [];
  deliveryInstructionList: any = [];
  selectedFormData: CppUserListFormsData;
  returnAccountNo: number;
  enableCreate: boolean = true;
  isSubmitEnable: boolean = false;
  orderViewtoggle: boolean = false;
  shipToDataLoading: boolean = true;
  isSaveClicked: boolean = false;
  MaxlengthErrorMsg: string = '';
  emailPattern = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  userMenuAccessList: any;
  headerCompany = MasterConstants.US_COMPANYCODE;

  constructor(
    public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private router: Router,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private cppUserListService: CppUserListService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private matDialog: MatDialog,
    public datepipe: DatePipe,
    private toastrService: ToastrService,
    private commonService: CommonService
  ) {
    this.dashboardFilter = new DashboardFilter();
    this.selectedFormData = new CppUserListFormsData();

    this.subscription.push(this.broadcastService
      .on<any>(this.configService.DATA_CHANGE_ADDED)
      .subscribe((data) => {
        if (data.hasChangeAdded != undefined) {
          this.hasChangeAdded = data.hasChangeAdded;
        }
      }));
  }

  ngOnInit() {
    this.loaderService.setLoaderStatus(true);
    this.getShipToAndDeliverToData();
    // this.GetMasterData();
    //this.contactTypeList = ContactType;
    // this.deliveryInstructionList = DeliveryCodeList;

    this.errorMsgs = new Array();
    setTimeout((x) => {

      if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
        const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
        if (evolveAccessData) {
          this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
          if (this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_USER_LIST, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList)) {
            this.accessTypeMode = true;
          }
        }
      }

      // Get Return Request Id for edit
      if (this.cppUserListService.editDeliveryAccountNo) {
        this.returnAccountNo = this.cppUserListService.editDeliveryAccountNo;
        this.isEditMode = true;
        this.enableCreate = false;
        this.getUserListDetails();
      }
      else {
        this.enableCreate = true;
      }

      this.loaderService.setLoaderStatus(false);
    }, 500);
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  onAddRecord() {
    const blankData = new CppUserListData();
    this.isSubmitEnable = true;
    // assigning id based on the data present in last of array
    const prevData =
      this.cppUserListDS?.data == undefined
        ? []
        : this.cppUserListDS.data;
    if (prevData && prevData.length < 10) {
      blankData.id =
        prevData.length == 0 ? prevData.length + 1 : prevData.slice(-1)[0].id + 1;
      blankData.firstName = '';
      blankData.lastName = '';
      blankData.email = '';
      blankData.lineErrors = { itemId: blankData.id, errors: [] };
      blankData.lineError = false;
      blankData.toBeValidated = true;
      blankData.isActive = true;
      if (prevData.length > 0) {
        prevData.map((x) => {
          x['toBeValidated'] = false;
          return x;
        });
      }
      this.cppUserListDS = new MatTableDataSource([
        ...prevData,
        blankData,
      ]);
      this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.cppUserListDS.data)));
      this.enableSaveDeliveryInstruction();
    }
    else {
      this.toastrService.error(
        'Cannot add more than 10 records.'
      );
    }
  }

  deleteProducts(data: any) {
    const title = 'Delete';
    const message = 'Do you want to delete this saved record?';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: {
        title: title,
        message: message,
        labelYes: 'Yes',
        labelNo: 'No',
        dialogType: 'confirm',
      },
    });

    this.subscription.push(dialogRef.afterClosed().subscribe((result) => {
      // If user selected Yes
      if (result == true) {
        this.loaderService.setLoaderStatus(true);
        if (!data.contactId) {
          this.cppUserListDS = new MatTableDataSource(this.cppUserListDS?.data.filter(x => x.id != data.id));
          this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.cppUserListDS?.data.filter(x => x.id != data.id))));
          if (this.cppUserListDS?.data.length == 0) {
            this.router.navigate(['/cpp/cpp-user-list']);
          }
          this.loaderService.setLoaderStatus(false);
        } else {
          this.subscription.push(this.cppUserListService
            .deleteUserList(data.contactId)
            .subscribe(
              (result) => {
                this.loaderService.setLoaderStatus(false);
                this.toastrService.success(
                  'Contact List deleted successfully.'
                );
                this.cppUserListDS = new MatTableDataSource(this.cppUserListDS?.data.filter(x => x.id != data.id));
                this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.cppUserListDS?.data.filter(x => x.id != data.id))));
                if (this.cppUserListDS?.data.length == 0) {
                  this.router.navigate(['/cpp/cpp-user-list']);
                }
              },
              (error) => LolLoggerService.error(error)
            ));
        }
      }
    }));
  }

  onGridInputChange(data: CppUserListData, fieldName: string) {
    this.isSubmitEnable = true;
    // Find index of specific object using findIndex method.
    const tempData = this.cppUserListDS?.data;
    const objIndex = tempData.findIndex((obj) => obj.id == data.id);

    // Update object's name property.
    tempData[objIndex][fieldName] = data[fieldName];
    this.cppUserListDS = new MatTableDataSource(tempData);

    //this.validateOrder()
    this.validateUserListFeildDS(tempData[objIndex], fieldName);
  }

  onAccountInputChange() {
    if (this.selectedFormData.accountNumber) {
      this.getUserListDetailsByAccount(this.selectedFormData.accountNumber)
      if (this.cppUserListDS && this.cppUserListDS?.data) {
        const res = this.CompareArray(this.cppUserListDS.data, this.originalProductItemsDataSource.data)
        this.isSubmitEnable = !res;
      }
    }
  }

  getUserListDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppUserListService
      .getcppUser(this.returnAccountNo)
      .subscribe(
        (result) => {
          if (result.length > 0) {
            
            this.selectedFormData.accountNumber = this.returnAccountNo;
            const tempData = result
              .sort((a, b) => b - a)
              .map((x, count) => {
                x['id'] = count + 1;
                x['lineErrors'] = new LineError();
                x['lineError'] = false;
                x['toBeValidated'] = false;
                return x;
              });
            this.selectedFormData.userListData = tempData;
            this.selectedFormData.updatedBy = tempData[0].updateUser;
            this.selectedFormData.dateUpdated = this.datepipe.transform(
              tempData[0].updateTimeStamp,
              'MM/dd/yyyy'
            );
            this.cppUserListDS = new MatTableDataSource(result);
            this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(result)));

            this.loaderService.setLoaderStatus(false);
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  getUserListDetailsByAccount(accountNumber: any) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppUserListService
      .getcppUser(accountNumber)
      .subscribe(
        (result) => {
          if (result.length > 0) {           
            this.selectedFormData.accountNumber = accountNumber;
            const tempData = result
              .sort((a, b) => b - a)
              .map((x, count) => {
                x['id'] = count + 1;
                x['lineErrors'] = new LineError();
                x['lineError'] = false;
                x['toBeValidated'] = false;
                return x;
              });
            this.selectedFormData.userListData = tempData;
            this.selectedFormData.updatedBy = tempData[0].updateUser;
            this.selectedFormData.dateUpdated = this.datepipe.transform(
              tempData[0].updateTimeStamp,
              'MM/dd/yyyy'
            );
            this.cppUserListDS = new MatTableDataSource(result);
            this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(result)));
            this.returnAccountNo = accountNumber;
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.cppUserListDS = new MatTableDataSource();
            this.originalProductItemsDataSource = new MatTableDataSource();
            this.returnAccountNo = accountNumber;
            this.selectedFormData.updatedBy = '';
            this.selectedFormData.dateUpdated = null;
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight =
      window.innerHeight -
      $('.navbar').outerHeight() -
      $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  navigateToUserList() {
    this.router.navigate(['/cpp/cpp-user-list']);
  }

  checkAnyValidLineItem() {
    const errorCount = this.cppUserListDS.data.filter(
      (x) => x.lineErrors.errors.length > 0
    ).length;
    return errorCount > 0 ? false : true;
  }

  enableSaveDeliveryInstruction() {
    if (
      this.cppUserListDS &&
      this.cppUserListDS.data.length > 0 &&
      this.selectedFormData.accountNumber &&
      this.checkAnyValidLineItem()
    ) {
      this.isSubmitEnable = true;
    } else {
      this.isSubmitEnable = false;
    }
  }

  CompareArray(result1, result2) {
    // Find values that are in result1 but not in result2
    const uniqueResultOne = result1.filter(function (obj) {
      return !result2.some(function (obj2) {
        return obj.value == obj2.value;
      });
    });

    // Find values that are in result2 but not in result1
    const uniqueResultTwo = result2.filter(function (obj) {
      return !result1.some(function (obj2) {
        return obj.value == obj2.value;
      });
    });
    return uniqueResultOne.length == 0 && uniqueResultTwo.length == 0;
  }

  validateOrder() {
    let isValidated = true;
    if (this.cppUserListDS.data && this.cppUserListDS.data.length > 0) {
      isValidated = true;
      this.cppUserListDS.data.forEach((x) => {
        x = this.validateUserListDS(x);
        if (x.lineErrors.errors.length > 0) {
          isValidated = false;
        }
      });
    }
    return isValidated;
  }
  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    } else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex((x) => x.id == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].id;
      this.currentErrorRow = this.index + 1;
      $('#returnRequestView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset()
          .top;
        $('#returnRequestView').animate({ scrollTop: nextOffset }, 1000);
      }
    } else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].id;
      this.currentErrorRow = 1;
      $('#returnRequestView').scrollTop = 0;
      $('#returnRequestView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (
      element &&
      element != null &&
      this.originalProductItemsDataSource.data.length > 0 &&
      this.cppUserListDS.data.length > 0
    ) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.originalProductItemsDataSource.data.filter(
          (x) => x.id === element.id
        )[0];
        oldLineValue.lineErrors = { itemId: oldLineValue.id, errors: [] };

        // get current object index
        const currentLineIndex = this.cppUserListDS.data.findIndex(
          (x) => x.id === element.id
        );

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          const tempData = this.cppUserListDS.data;
          const oldData = JSON.parse(JSON.stringify(oldLineValue));
          if (tempData[currentLineIndex].lineErrors.errors && tempData[currentLineIndex].lineErrors.errors.length > 0) {
            tempData[currentLineIndex].lineErrors.errors.forEach(e => {
              const error = JSON.parse(JSON.stringify(e));
              if (error.id == 'firstName') {
                tempData[currentLineIndex].firstName = oldData.firstName;
              }
              else if (error.id == 'lastName') {
                tempData[currentLineIndex].lastName = oldData.lastName;
              }              
              else if (error.id == 'email') {
                tempData[currentLineIndex].email = oldData.email;
              }           
            });
          }
          tempData[currentLineIndex].lineErrors = oldData.lineErrors;
          tempData[currentLineIndex].lineError = oldData.lineError;
          this.cppUserListDS = new MatTableDataSource(tempData);
          const index = this.errorMsgs.findIndex((x) => parseInt(x.itemId) == oldLineValue.id);
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.id);
          this.getCommonErrors(this.errorMsgs);
        }
      } else {
        // replace whole object

        // replace the new value with old value if it has error;
        this.cppUserListDS.data.forEach(x => {
          if (x.lineErrors.errors && x.lineErrors.errors.length > 0) {
            const tempData = JSON.parse(JSON.stringify(this.originalProductItemsDataSource.data.filter(o => o.id == x.id)[0]));
            x.lineErrors.errors.forEach(e => {
              const error = JSON.parse(JSON.stringify(e));
              if (error.id == 'firstName') {
                x.firstName = tempData.firstName;
              }
              else if (error.id == 'lastName') {
                x.lastName = tempData.lastName;
              }              
              else if (error.id == 'email') {
                x.email = tempData.email;
              }
              
            });
          }

          x.lineErrors = { itemId: x.id, errors: [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.isSubmitEnable = false;
    }
    this.enableSaveDeliveryInstruction();
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
    this.enableSaveDeliveryInstruction();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    } else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach((x) => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  validateUserListFeildDS(productItem: any, fieldName: any) {   
    if (fieldName === 'firstName') {
      if (productItem.firstName === '' || productItem.firstName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        productItem.lineErrors.errors.push({
          id: 'firstName',
          error: 'Please enter a first name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'lastName') {
      if (productItem.lastName === '' || productItem.lastName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        productItem.lineErrors.errors.push({
          id: 'lastName',
          error: 'Please enter a last name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'email') {
      if (productItem.email === '' || productItem.email === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'email'
        );
        productItem.lineErrors.errors.push({
          id: 'email',
          error: 'Please enter a email address',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'email'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
        if (
          productItem.email !== '' ||
          productItem.email !== ''
        ) {
          if (!this.validateEmail(productItem.email)) {
            productItem.lineErrors.errors.push({
              id: 'email',
              error: 'Please enter a valid email addresss',
            });
            productItem.lineErrors.itemId = productItem.id;
          }
          else {
            console.log(this.cppUserListDS.data);
            if (this.cppUserListDS.data.filter(x => x.email == productItem.email.trim()).length > 1) {
              productItem.lineErrors.errors.push({
                id: 'email',
                error: 'Email address should be unique',
              });
              productItem.lineErrors.itemId = productItem.id;
            }
          }
        }
        else {
          productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
            (y) => y.id != 'email'
          );
          var index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === productItem.id;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
        }
      }
    }   

    if (productItem.lineErrors.errors.length > 0) {
      if ((this.errorMsgs.filter((x) => x.itemId == productItem.id)).length > 0) {
        this.errorMsgs.map((x) => {
          if (x.itemId == productItem.id) {
            x['errors'] = productItem.lineErrors.errors;
            return x;
          }
        });
      }
      else {
        this.errorMsgs.push(productItem.lineErrors);
      }
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  validateUserListDS(productItem: any) {
    if (!productItem.toBeValidated || this.isSaveClicked) {     
      if (productItem.firstName === '' || productItem.firstName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        productItem.lineErrors.errors.push({
          id: 'firstName',
          error: 'Please enter a first name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'firstName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.lastName === '' || productItem.lastName === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        productItem.lineErrors.errors.push({
          id: 'lastName',
          error: 'Please enter a last name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'lastName'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.email === '' || productItem.email === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'email'
        );
        productItem.lineErrors.errors.push({
          id: 'email',
          error: 'Please enter a email address',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'email'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
        if (
          productItem.email !== '' ||
          productItem.email !== ''
        ) {
          if (!this.validateEmail(productItem.email)) {
            productItem.lineErrors.errors.push({
              id: 'email',
              error: 'Please enter a valid email address',
            });
            productItem.lineErrors.itemId = productItem.id;
          }
          else {
            console.log(this.cppUserListDS.data);
            if (this.cppUserListDS.data.filter(x => x.email == productItem.email.trim()).length > 1) {
              productItem.lineErrors.errors.push({
                id: 'email',
                error: 'Email address should be unique',
              });
              productItem.lineErrors.itemId = productItem.id;
            }
          }
        }
        else {
          productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
            (y) => y.id != 'email'
          );
          var index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === productItem.id;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
        }
      }
    }

    if (productItem.lineErrors.errors.length > 0) {
      this.errorMsgs.push(productItem.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  saveUserList() {
    this.isSaveClicked = true;
    if (this.validateOrder()) {
      if (this.cppUserListDS.data.length > 0) {
        this.cppUserListDS.data.map((x) => {
          x['accountNumber'] = this.selectedFormData.accountNumber;
          //x.deliveryInstructions = x.selectedDeliveryInstructions ? x.selectedDeliveryInstructions.join(',') : '';
          return x;
        });
      }
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppUserListService
        .saveUserList(this.cppUserListDS.data)
        .subscribe(
          (result) => {
            if (this.isEditMode) {
              this.toastrService.success(
                'Contact List updated successfully.'
              );
            } else {
              this.toastrService.success(
                'Contact List saved successfully.'
              );
            }
            this.returnAccountNo = this.selectedFormData.accountNumber;
            this.getUserListDetails();
            this.loaderService.setLoaderStatus(false);
          },
          (error) => LolLoggerService.error(error)
        ));
    }
    else {
      this.isSaveClicked = false;
      const prevData = this.cppUserListDS.data;
      prevData.map((x) => {
        x['toBeValidated'] = false;
        return x;
      });
      this.cppUserListDS = new MatTableDataSource(prevData);
      this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(prevData)));
    }
  }
  // Go to landing cpp delivery page
  navigateTolandingUserList() {
    this.router.navigate(['/cpp/cpp-user-list']);
  }

  // Get the shipto and  deliver to for dropdown DeliverTo
  getShipToAndDeliverToData() {
    this.subscription.push(this.cppUserListService
      .getDeliveryInstructionAccountList()
      .subscribe(
        (result) => {
          this.shipToData = result;
          this.shipToDataLoading = false;
        },
        (error) => LolLoggerService.error(error)
      ));
  }
  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return (
      item.accountName.toLocaleLowerCase().indexOf(term) > -1 ||
      item.accountNumber.toString().indexOf(term) > -1 ||
      item.address1.toLocaleLowerCase().indexOf(term) > -1 ||
      item.city.toLocaleLowerCase().indexOf(term) > -1 ||
      item.state.toLocaleLowerCase().indexOf(term) > -1 ||
      item.zipCode.toLocaleLowerCase().indexOf(term) > -1
    );
  }

  // Validate the email address entered
  validateEmail(emailId: string) {
    return this.emailPattern.test(emailId);
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
